import React from 'react';
import { Link, Text } from '@heartinternet/hi-ui';
import './StatusPage.css';

/** The offsite system-status page the "here" link points to. Legacy served this
 *  over http://; upgraded to https:// here (the site is https-native and 308s
 *  http→https anyway, so this drops a needless insecure first hop). */
const DEFAULT_STATUS_URL = 'https://www.webhostingstatus.com/';

export interface StatusPageProps {
  /**
   * Offsite system-status URL the "here" link points to.
   * Defaults to www.webhostingstatus.com.
   */
  statusUrl?: string;
}

/**
 * System Status — /manage/status.cgi.
 *
 * A static informational page that directs customers to the offsite system-status
 * page. The customer portal does not display status data itself. Page chrome
 * (nav, sidebar, footer, breadcrumbs) is provided by the Page organism at mount.
 */
export const StatusPage: React.FC<StatusPageProps> = ({ statusUrl = DEFAULT_STATUS_URL }) => {
  return (
    <div className="hi-ui-status-page">
      <Text variant="heading-1">System Status</Text>

      <Text variant="body">
        Our system status page is located in an offsite location so that it can be accessed
        externally.
      </Text>

      <Text variant="body">
        We suggest you add our system status page to your web browser favourites so that it can be
        easily accessed if our customer control panel is inaccessible. Click the &apos;Add to
        favourites&apos; link on the status page to do this. If you are having a connection issue
        with your website or email please check the system status page before contacting customer
        support.
      </Text>

      <Text variant="body">
        Click{' '}
        <Link href={statusUrl} external>
          here
        </Link>{' '}
        to open www.webhostingstatus.com in a new window.
      </Text>
    </div>
  );
};
